// 26/06 #185: modal de aviso quando atendente tenta aceitar ticket fora da ordem de chegada.
// Aparece quando o backend retorna 409 (warn) ou 403 (block) com payload { action, olderTicket }.

import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { i18n } from "../../translate/i18n";

const OlderPendingTicketWarningModal = ({
  open,
  onClose,
  olderTicket,
  action,
  onAcceptOldest,
  onForceAccept
}) => {
  if (!olderTicket) return null;

  const isBlock = action === "block";

  const queueLabel = olderTicket.queueName
    ? ` (${olderTicket.queueName})`
    : "";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {isBlock
          ? i18n.t("olderPendingTicketWarning.titleBlock")
          : i18n.t("olderPendingTicketWarning.titleWarn")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {i18n.t("olderPendingTicketWarning.message", {
            contactName: olderTicket.contactName,
            queueLabel,
            waitingMinutes: olderTicket.waitingMinutes
          })}
        </DialogContentText>
        {isBlock && (
          <DialogContentText style={{ marginTop: 8, fontStyle: "italic" }}>
            {i18n.t("olderPendingTicketWarning.blockHint")}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default">
          {i18n.t("olderPendingTicketWarning.cancel")}
        </Button>
        <Button onClick={onAcceptOldest} color="primary" variant="contained">
          {i18n.t("olderPendingTicketWarning.acceptOldest")}
        </Button>
        {!isBlock && (
          <Button onClick={onForceAccept} color="secondary">
            {i18n.t("olderPendingTicketWarning.acceptAnyway")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

OlderPendingTicketWarningModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  olderTicket: PropTypes.object,
  action: PropTypes.oneOf(["warn", "block"]),
  onAcceptOldest: PropTypes.func.isRequired,
  onForceAccept: PropTypes.func
};

export default OlderPendingTicketWarningModal;
